import React from "react";
import { Text, Box, Button, Grid } from "@chakra-ui/react";
import { useMenu, type UseMenuProps } from "react-instantsearch";

type AlgoliaSearchFiltersProps = UseMenuProps & {
  query: string;
};

const attrsToCapitalize = new Set(["type", "experienceLevel"]);

export function AlgoliaSearchFilters({ attribute, query, ...useMenuProps }: AlgoliaSearchFiltersProps) {
  const { items, refine } = useMenu({
    attribute,
    limit: 30,
    sortBy: ["name:asc"],
    ...useMenuProps,
  });

  return (
    <Grid as="ul" gap={2} mb={8} listStyleType="none">
      {items?.map((filter) => {
        return (
          <Box key={filter.label} as="li">
            <Button
              variant="unstyled"
              fontWeight="semibold"
              position="relative"
              textDecoration={filter.isRefined ? "underline" : "none"}
              textUnderlineOffset={3}
              color={filter.isRefined ? "grass" : "text.secondary"}
              fontSize="sm"
              h="100%"
              _hover={{ color: filter.isRefined ? "grass" : "text.primary" }}
              textTransform={attrsToCapitalize.has(attribute) ? "capitalize" : "none"}
              onClick={() => {
                // Don't refine if filter is already selected
                if (!filter.isRefined) {
                  refine(filter.value);
                }
              }}
            >
              {filter.label}
              {query !== "" && (
                <Text as="span" ml={1}>
                  ({filter.count})
                </Text>
              )}
            </Button>
          </Box>
        );
      })}
    </Grid>
  );
}
